
















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
let uniqueId = 0;

@Component
export default class extends Vue {
  @Prop({
    default: () => {
      return `simple-input-${uniqueId++}`;
    },
  })
  public id!: string;

  @Prop({ default: '' })
  public value!: string;

  @Prop({ default: 'text' })
  public type!: string;

  @Prop({ default: '' })
  public placeholder!: string;

  @Emit('change')
  private onInput(evt: Event) {
    return (evt.target && (evt.target as HTMLInputElement).value) || '';
  }

  @Emit('focus')
  private onFocus() {
    //
  }
  @Emit('blur')
  private onBlur() {
    //
  }
}
